






























import { Component, Vue, Prop } from 'vue-property-decorator'

const AutosizeTextarea = () => import('./AutosizeTextarea.vue')

@Component({
  components: {
    AutosizeTextarea,
  },
  inheritAttrs: false,
})
export default class TextInput extends Vue {
  @Prop({ type: String, default: 'text' })
  type!: 'text' | 'textarea'

  @Prop({ type: String, default: '' })
  value!: string

  @Prop({ type: String, default: '' })
  width!: string

  @Prop({ type: String, default: '' })
  label!: string

  get inputValue() {
    return this.value
  }
  set inputValue(newText: string) {
    this.$emit('input', newText)
    this.$nextTick(() => this.$emit('change'))
  }

  screenWidth = 50

  mounted() {
    if (!this.$el) return
    let width = Math.floor(this.$el.clientWidth / 8) - 15
    if (width > 50) width = 50
    this.screenWidth = width
  }

  @Prop({ type: Function, default: () => true })
  validator!: (answer: string) => boolean

  get valid() {
    return this.validator(this.inputValue)
  }

  get required() {
    return !this.validator('')
  }
}
